import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { ReplicationService } from '../../replication/replication.service';
import { IndexRebuildComponent } from '../index-rebuild/index-rebuild.component';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    standalone: false
})
export class HomeComponent implements OnInit {
  private replicationService = inject(ReplicationService);

  @ViewChild(IndexRebuildComponent, { static: true })
  private indexResetComponent;

  serverMode: string;

  ngOnInit() {
    this.replicationService.getSyncGatewayStatus().subscribe((status) => {
      if (status) {
        this.serverMode = status.serverMode;
      }
    });
  }

  resetIndexes() {
    this.indexResetComponent.show();
  }
}
